<!--
  name : 김혜진
  desc :
  date : 2020-07-29
-->
<template>
  <v-container>
    <v-dialog v-model="dialogId" persistent scrollable max-width="600px">
      <v-card id="popStyle02" class="popWgeust">
        <v-row no-gutters class="scrollH100_x">
          <v-form lazy-validation>
            <v-col cols="12">
              <span class="fc_C03">[{{ ctrInfo.senderName }}]</span>
              <span>에서 전송한 전자계약을 확인 하세요.</span>
            </v-col>
            <v-col cols="12">
              <span class="fs_18">[{{ ctrInfo.contractFileName }}]</span>
            </v-col>
            <v-col cols="12">
              <div v-if="nomemberShow === true">
                <!-- 선우 트라이 진흥원만 -->
                글로싸인엔터프라이즈를 통해 체결된 전자계약서를 비회원으로
                확인합니다.
              </div>
              <!--회원 있는 거래처만 보여야 하는 경우 -->
              <div v-if="nomemberShow === false">
                글로싸인엔터프라이즈를 통해 체결된 전자계약서를 안전하게 보관 및
                관리하기 위해 회원으로 간편 전환후 계약서 확인을 추천합니다.
              </div>
            </v-col>
          </v-form>
          <v-card-actions no-gutters class="justify-center">
            <v-col cols="12">
              <!--회원 있는 거래처만 보여야 하는 경우 -->
              <div v-if="nomemberShow === false">
                <v-btn
                  outlined
                  class="btn19_00 btnW100p btnC_01 mb-4"
                  @click="changeMember"
                  >간편 회원 전환 후<br />전자계약서를 확인 합니다.</v-btn
                >
              </div>
              <!--전부 다 보여야 하는 경우 -->
              <v-btn outlined class="btn19_00 btnW100p" @click="openContract"
                >비회원으로 해당 계약서를 확인 합니다.</v-btn
              >

              <div v-if="ctrInfo.contractNumber.startsWith('TRI')">
                <v-btn
                  outlined
                  class="btn19_00 btnW100p"
                  style="margin-top:10px !important;"
                  @click="openCert"
                  >범용 공인인증서 발급하기</v-btn
                >
              </div>
            </v-col>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
    <pubCert
      ref="pubCert"
      :certRegno="purCertInfo.certRegNo"
      :hash="purCertInfo.hash"
      @childs-event="purCertResult"
    ></pubCert>
    <perCert
      ref="perCert"
      :perName="perCerInfo.perName"
      :perNumber="perCerInfo.perNumber"
      @per-event="perCertResult"
    ></perCert>
    <passCheck
      ref="passCheck"
      :ctrNumber="ctrInfo.contractNumber"
      @pass-event="passCheckResult"
    ></passCheck>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>
import {
  contractLockRead,
  ctrLockReadSuc,
  ctrLockReadFail,
  ctrLockReadPerSuc,
  NoMem
} from "@/api/contractLock";
import PubCert from "@/components/pubCert";
import PerCert from "@/components/perCert";
import passCheck from "@/components/passCheck";

export default {
  name: "contractLock",
  components: {
    PubCert,
    PerCert,
    passCheck
  },
  filters: {},
  data() {
    return {
      dialogId: false,
      purCertInfo: {
        certRegNo: "",
        hash: ""
      },
      perCerInfo: {
        perName: "",
        perNumber: ""
      },
      ctrInfo: {
        contractNumber: "",
        contractSeq: "",
        ctrLockType: "",
        failCnt: "",
        stat: "",
        signType: "",
        acqDate: "",
        resultCode: "",
        email: "",
        senderName: "",
        contractFileName: "",
        receiverName: "",
        receiverAddress: "",
        contractStatus: ""
      },
      chainAddress: "",
      vid: "",
      sign: "",
      errorMessage: "",
      result: "",
      acq: "",
      MemberYn: "",
      nomemberShow: false
    };
  },
  created() {
    this.ctrInfo.contractNumber = this.$route.query.contNo;

    if (this.ctrInfo.contractNumber.startsWith("SWF")) {
      this.nomemberShow = true;
    } else if (this.ctrInfo.contractNumber.startsWith("TRI")) {
      this.nomemberShow = true;
    }else if (this.ctrInfo.contractNumber.startsWith("KRH")) {
      this.nomemberShow = true;
    } else {
      this.nomemberShow = false;
    }

    this.ctrInfo.contractSeq = this.$route.query.contSeq;
  },
  mounted() {
    this.track();
    this.$nextTick(() => {
      this.readDatas();
    });
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: "/contrackLock"
      });
    },
    readDatas() {
      contractLockRead(
        JSON.stringify({
          contractNumber: this.ctrInfo.contractNumber,
          contractSeq: this.ctrInfo.contractSeq
        })
      ).then(response => {
        console.log("read", response.rdata.perNumber);
        this.chainAddress = response.rdata.chainAddress;
        this.ctrInfo.resultCode = response.rcode;
        this.ctrInfo.senderName = response.rdata.contract.senderName;
        this.ctrInfo.contractFileName =
          response.rdata.contract.contractFileName;
        if (
          response.rdata.contract.receiverBrokerName !== "" &&
          response.rdata.contract.receiverBrokerName !== null
        ) {
          this.ctrInfo.receiverName =
            response.rdata.contract.receiverName +
            " " +
            response.rdata.contract.receiverBrokerName;
          this.ctrInfo.receiverAddress =
            response.rdata.contract.receiverBrokerAddress;
        } else {
          this.ctrInfo.receiverName = response.rdata.contract.receiverName;
          this.ctrInfo.receiverAddress =
            response.rdata.contract.receiverAddress;
        }
        this.ctrInfo.contractSeq = response.rdata.ctrSeq;
        this.ctrInfo.failCnt = response.rdata.failCnt;
        this.ctrInfo.stat = response.rdata.stat;
        this.ctrInfo.ctrLockType = response.rdata.ctrLockType;
        this.ctrInfo.signType = response.rdata.ctrSignType;
        this.ctrInfo.email = response.rdata.email;
        this.ctrInfo.contractStatus = response.rdata.contract.contractStatus;

        this.MemberYn = response.rdata.MemberYn;

        if (this.MemberYn === "Y") {
          this.$router.push({ name: "login" });
        }

        if (this.ctrInfo.signType === 1 || this.ctrInfo.ctrLockType === 1) {
          this.purCertInfo.certRegNo = response.rdata.certRegNo;
        }
        if (this.ctrInfo.ctrLockType === 2 || this.ctrInfo.ctrLockType === 4) {
          this.perCerInfo.perName = response.rdata.perName;
          this.perCerInfo.perNumber = response.rdata.perNumber;
        }

        this.acq = response.rdata.acq;

        if (this.ctrInfo.contractNumber.indexOf("KMH-") > -1) {
          this.openContract();
        } else {
          this.dialogId = true;
        }
      });
    },
    openContract() {
      if (this.ctrInfo.stat === "CA") {
        this.$refs.confirm.open(
          "alert",
          "요청취소",
          "해당 계약은 요청취소가 되었습니다."
        );
      } else {
        NoMem(JSON.stringify({ chainAddress: this.chainAddress })).then(
          response => {
            if (response.rcode === 20000) {
              this.$store.dispatch("NoMemLogin", response.rdata);
              if (this.ctrInfo.resultCode === 20000) {
                if (this.ctrInfo.failCnt > 4) {
                  this.$refs.confirm.open(
                    "alert",
                    "인증잠김",
                    "해당 계약은 인증 5번 실패했습니다. 고객센터에 문의해주세요"
                  );
                } else if (this.ctrInfo.ctrLockType === 0 || this.acq === "Y") {
                  this.$nextTick(() => {
                    this.goDetail();
                  });
                } else if (this.ctrInfo.ctrLockType === 1) {
                  this.$nextTick(() => {
                    this.$refs.pubCert.open();
                  });
                } else if (this.ctrInfo.ctrLockType === 2) {
                  this.$nextTick(() => {
                    this.$refs.perCert.open();
                  });
                } else if (this.ctrInfo.ctrLockType === 3) {
                  this.$nextTick(() => {
                    this.$refs.passCheck.open();
                  });
                } else if (this.ctrInfo.ctrLockType === 4) {
                  this.$nextTick(() => {
                    this.$refs.passCheck.open();
                  });
                }
              }
            }
          }
        );
      }
    },
    changeMember() {
      this.$router.push({
        name: "changeMember",
        params: {
          contractNumber: this.ctrInfo.contractNumber,
          contractSeq: this.ctrInfo.contractSeq,
          email: this.ctrInfo.email
        }
      });
    },
    purCertResult: function(vid, errorMessage, sign, certPEM) {
      this.errorMessage = errorMessage;
      if (vid) {
        ctrLockReadSuc(
          JSON.stringify({
            contractSeq: this.ctrInfo.contractSeq,
            contractNumber: this.ctrInfo.contractNumber,
            contractFileName: this.ctrInfo.contractFileName,
            receiverName: this.ctrInfo.receiverName,
            receiverAddress: this.ctrInfo.receiverAddress
          })
        ).then(
          this.$nextTick(() => {
            this.goDetail();
          })
        );
      } else {
        this.ctrInfo.failCnt = this.ctrInfo.failCnt + 1;
        ctrLockReadFail(
          JSON.stringify({
            contractSeq: this.ctrInfo.contractSeq,
            failCnt: this.ctrInfo.failCnt
          })
        ).then(
          this.$nextTick(() => {
            this.$refs.confirm.open(
              "alert",
              "인증실패",
              "인증 " +
                this.ctrInfo.failCnt +
                "번 실패하였습니다.<br>" +
                this.errorMessage
            );
            if (this.ctrInfo.failCnt < 5) {
              this.$refs.pubCert.open();
            }
          })
        );
      }
    },
    perCertResult: function(vid, errorMessage) {
      this.errorMessage = errorMessage;
      console.log("vid", vid);
      if (vid) {
        ctrLockReadPerSuc(
          JSON.stringify({
            contractSeq: this.ctrInfo.contractSeq,
            ci: this.errorMessage,
            contractNumber: this.ctrInfo.contractNumber,
            contractFileName: this.ctrInfo.contractFileName,
            receiverName: this.ctrInfo.receiverName,
            receiverAddress: this.ctrInfo.receiverAddress
          })
        ).then(
          this.$nextTick(() => {
            this.goDetail();
          })
        );
      } else {
        this.ctrInfo.failCnt = this.ctrInfo.failCnt + 1;
        ctrLockReadFail(
          JSON.stringify({
            contractSeq: this.ctrInfo.contractSeq,
            failCnt: this.ctrInfo.failCnt
          })
        ).then(
          this.$nextTick(() => {
            this.$refs.confirm.open(
              "alert",
              "인증실패",
              "인증 " +
                this.ctrInfo.failCnt +
                "번 실패하였습니다.<br>" +
                this.errorMessage
            );
            if (this.ctrInfo.failCnt < 5) {
              this.$refs.perCert.open(
                this.perCerInfo.perName,
                this.perCerInfo.perNumber
              );
            }
          })
        );
      }
    },
    passCheckResult: function(result) {
      if (result) {
        if (this.ctrInfo.ctrLockType === 4) {
          this.$refs.perCert.open();
        } else {
          ctrLockReadSuc(
            JSON.stringify({
              contractSeq: this.ctrInfo.contractSeq,
              contractNumber: this.ctrInfo.contractNumber,
              contractFileName: this.ctrInfo.contractFileName,
              receiverName: this.ctrInfo.receiverName,
              receiverAddress: this.ctrInfo.receiverAddress
            })
          ).then(
            this.$nextTick(() => {
              this.goDetail();
            })
          );
        }
      } else {
        this.ctrInfo.failCnt = this.ctrInfo.failCnt + 1;
        ctrLockReadFail(
          JSON.stringify({
            contractSeq: this.ctrInfo.contractSeq,
            failCnt: this.ctrInfo.failCnt
          })
        ).then(
          this.$nextTick(() => {
            this.$refs.confirm.open(
              "alert",
              "인증실패",
              "인증 " +
                this.ctrInfo.failCnt +
                "번 실패하였습니다.<br>" +
                this.errorMessage
            );
            if (this.ctrInfo.failCnt < 5) {
              this.$refs.passCheck.open(this.certRegNo);
            }
          })
        );
      }
    },
    goDetail() {
      if (this.ctrInfo.contractStatus === "XX") {
        this.$refs.confirm.open(
          "alert",
          "계약열람",
          "현재 해당계약서는 열람할 수 없습니다."
        );
      } else {
        if (this.ctrInfo.contractNumber.indexOf("DWF-") >= 0) {
          this.$router.push({
            name: "dongwonLockDetail",
            params: {
              contractNumber: this.ctrInfo.contractNumber,
              contractSeq: this.ctrInfo.contractSeq,
              certRegNo: this.purCertInfo.certRegNo
            }
          });
        } else if (
          this.ctrInfo.contractNumber.indexOf("SJDR-") >= 0 ||
          this.ctrInfo.contractNumber.indexOf("SJOY-") >= 0
        ) {
          this.$router.push({
            name: "sajoLockDetail",
            params: {
              contractNumber: this.ctrInfo.contractNumber,
              contractSeq: this.ctrInfo.contractSeq,
              certRegNo: this.purCertInfo.certRegNo
            }
          });
        } else {
          this.$router.push({
            name: "lockDetail",
            params: {
              contractNumber: this.ctrInfo.contractNumber,
              contractSeq: this.ctrInfo.contractSeq,
              certRegNo: this.purCertInfo.certRegNo
            }
          });
        }
      }
    },

    openCert() {
      window.open("http://www.smartbill.co.kr/xMain/cert/app/app.aspx");
    }
  }
};
</script>
<style scoped></style>
